<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.printMultiples.search.name')" prop="name">
                <a-input v-model="queryParam.name" :placeholder="$t('views.printMultiples.search.namePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.printMultiples.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.printMultiples.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:printMultiples:add']">
          <a-icon type="plus" />{{ $t('views.printMultiples.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:printMultiples:edit']">
          <a-icon type="edit" />{{ $t('views.printMultiples.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:printMultiples:remove']">
          <a-icon type="delete" />{{ $t('views.printMultiples.btn.delete') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <a-drawer
        :title="optionDrawerTitle"
        placement="right"
        :width="optionDrawerWidth"
        :visible="optionDrawerVisible"
        :destroy-on-close="true"
        @close="closeOptionDrawer"
      >
        <print-multiples-option
          v-if="optionDrawerVisible && currentPrintMultiplesId != null"
          :key="'pm-opt-' + currentPrintMultiplesId"
          :fixed-print-multiples-id="currentPrintMultiplesId"
          :embedded="true"
        />
      </a-drawer>
      <a-drawer
        :title="specialMinimumDrawerTitle"
        placement="right"
        :width="specialMinimumDrawerWidth"
        :visible="specialMinimumDrawerVisible"
        :destroy-on-close="true"
        @close="closeSpecialMinimumDrawer"
      >
        <special-minimum
          v-if="specialMinimumDrawerVisible && currentSpecialMinimumPrintMultiplesId != null"
          :key="'pm-sm-' + currentSpecialMinimumPrintMultiplesId"
          :fixed-print-multiples-id="currentSpecialMinimumPrintMultiplesId"
          :embedded="true"
        />
      </a-drawer>
<!--             :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"-->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"

        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <!-- 表格排序列已注释
        <span slot="sort" slot-scope="text, record">
          <a-input-number
            :value="record.sort"
            :min="0"
            style="width: 100px"
            @change="(value) => handleSortChange(record, value, 'sort')"
          />
        </span>
        -->
        <span slot="status" slot-scope="text, record">
          <a-switch
            :checked="record.status == 1 || record.status == '1'"
            @change="(checked) => handleStatusChange(record, checked)"
          />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="openOptionDrawer(record)" v-hasPermi="['user:printMultiplesOption:list']">
            <a-icon type="link" />{{ $t('views.printMultiples.action.optionLink') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:specialMinimum:list']" />
          <a @click="openSpecialMinimumDrawer(record)" v-hasPermi="['user:specialMinimum:list']">
            <a-icon type="profile" />{{ $t('views.printMultiples.action.specialMinimum') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['user:printMultiples:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:printMultiples:edit']">
            <a-icon type="edit" />{{ $t('views.printMultiples.btn.edit') }}
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['user:printMultiples:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['user:printMultiples:remove']">-->
<!--            <a-icon type="delete" />{{ $t('views.printMultiples.btn.delete') }}-->
<!--          </a>-->
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePrintMultiples, delPrintMultiples, updatePrintMultiplesSort, updatePrintMultiplesStatus } from '@/api/user/printMultiples'
import CreateForm from './modules/CreateForm'
import PrintMultiplesOption from '@/views/user/printMultiplesOption/index.vue'
import SpecialMinimum from '@/views/user/specialMinimum/index.vue'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'PrintMultiples',
  components: {
    CreateForm,
    PrintMultiplesOption,
    SpecialMinimum
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      optionDrawerVisible: false,
      currentPrintMultiplesId: null,
      currentPrintMultiplesName: '',
      specialMinimumDrawerVisible: false,
      currentSpecialMinimumPrintMultiplesId: null,
      currentSpecialMinimumPrintMultiplesName: '',
      loading: false,
      total: 0,
      queryParam: {
        name: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: []
    }
  },
  created () {
    this.buildColumns()
    this.getList()
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    }
  },
  computed: {
    optionDrawerTitle () {
      return this.$t('views.printMultiples.drawer.optionLinkTitle')
    },
    optionDrawerWidth () {
      if (typeof window !== 'undefined' && window.innerWidth) {
        return Math.min(960, Math.floor(window.innerWidth * 0.88))
      }
      return 880
    },
    specialMinimumDrawerTitle () {
      const name = this.currentSpecialMinimumPrintMultiplesName || ''
      return this.$t('views.printMultiples.drawer.specialMinimumTitle', { name })
    },
    specialMinimumDrawerWidth () {
      if (typeof window !== 'undefined' && window.innerWidth) {
        return Math.min(960, Math.floor(window.innerWidth * 0.88))
      }
      return 880
    }
  },
  methods: {
    buildColumns () {
      const t = k => this.$t(k)
      this.columns = [
        { title: t('views.printMultiples.column.id'), dataIndex: 'id', ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.name'), dataIndex: 'name', ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.price'), dataIndex: 'price', ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.recyclingPrice'), dataIndex: 'recyclingPrice', ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.andDoubleNum'), dataIndex: 'andDoubleNum', ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.andBottomNum'), dataIndex: 'andBottomNum', ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.andThreeNum'), dataIndex: 'andThreeNum', ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.andFourNum'), dataIndex: 'andFourNum', ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.doubleDischarging'), dataIndex: 'doubleDischarging', ellipsis: true, align: 'center' },
        // { title: t('views.printMultiples.column.sort'), dataIndex: 'sort', scopedSlots: { customRender: 'sort' }, ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.status'), dataIndex: 'status', scopedSlots: { customRender: 'status' }, ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.createTime'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, ellipsis: true, align: 'center' },
        { title: t('views.printMultiples.column.operation'), dataIndex: 'operation', width: 400, fixed: 'right', scopedSlots: { customRender: 'operation' }, align: 'center' }
      ]
    },
    paginationShowTotal (total) {
      return this.$t('views.printMultiples.pagination.total', { total })
    },
    openOptionDrawer (record) {
      this.currentPrintMultiplesId = record.id
      this.currentPrintMultiplesName = record.name || ''
      this.optionDrawerVisible = true
    },
    closeOptionDrawer () {
      this.optionDrawerVisible = false
      this.currentPrintMultiplesId = null
      this.currentPrintMultiplesName = ''
    },
    openSpecialMinimumDrawer (record) {
      this.currentSpecialMinimumPrintMultiplesId = record.id
      this.currentSpecialMinimumPrintMultiplesName = record.name || ''
      this.specialMinimumDrawerVisible = true
    },
    closeSpecialMinimumDrawer () {
      this.specialMinimumDrawerVisible = false
      this.currentSpecialMinimumPrintMultiplesId = null
      this.currentSpecialMinimumPrintMultiplesName = ''
    },
    getList () {
      this.loading = true
     pagePrintMultiples(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        name: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('views.printMultiples.confirm.deleteTitle'),
        content: this.$t('views.printMultiples.confirm.deleteContent', { ids: ids }),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delPrintMultiples(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('views.printMultiples.msg.deleteSuccess'), 3)
          })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.printMultiples.confirm.exportTitle'),
        content: this.$t('views.printMultiples.confirm.exportContent'),
        onOk () {
          that.download('user/print-multiples/export', {
            ...that.queryParam
          }, that.$t('views.printMultiples.export.filename', { time: new Date().getTime() }))
        },
        onCancel () {}
      })
    },
    handleStatusChange (record, checked) {
      const statusValue = checked ? 1 : 0
      updatePrintMultiplesStatus({ id: record.id, status: statusValue }).then(() => {
        record.status = statusValue
        this.$message.success(this.$t('views.printMultiples.msg.statusOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.printMultiples.msg.statusFail'))
      })
    },
    handleSortChange (record, value, fieldName) {
      if (value === null || value === undefined) {
        return
      }
      updatePrintMultiplesSort({ id: record.id, sort: value }).then(() => {
        record[fieldName] = value
        this.$message.success(this.$t('views.printMultiples.msg.sortOk'))
        this.getList()
      }).catch(() => {
        this.$message.error(this.$t('views.printMultiples.msg.sortFail'))
      })
    }
  }
}
</script>
